//@flow
import * as React from 'react';
import { themr, type ThemeType } from 'react-css-themr';

import theme from './BeatVisitMarker.scss';
import FpVisitMarkerPopup from './FpVisitMarkerPopup';
import fpVisitMarkerFactory from './fpVisitMarkerFactory';
import FpFlagMarkerPopup from './FpFlagMarkerPopup';

import type { BeatVisit } from 'common/models/internal/BeatVisit';

import { Color } from 'common/models/internal/Color';
import FpVisitMarkerPopupOuter from './FpVisitMarkerPopupOuter';
import FpFlagMarkerPopupOuter from './FpFlagMarkerPopupOuter';
import FpHomebaseMarker from './FpHomebaseMarker';
import type { VisitIdOutletType } from 'common/entity/pjpMaster/planView/FpPlanDetailsContainer';

export const { ThemedVisitMarker: FpVisitMarker } = (fpVisitMarkerFactory(
    {
        VisitMarkerPopup: FpVisitMarkerPopup,
        VisitMarkerPopupOuter: FpVisitMarkerPopupOuter
    },
    { themed: true }
): any);

export const { ThemedVisitMarker: FpFlagMarker } = fpVisitMarkerFactory(
    {
        VisitMarkerPopup: FpFlagMarkerPopup,
        VisitMarkerPopupOuter: FpFlagMarkerPopupOuter
    },
    { themed: true }
);

export const { ThemedVisitMarker: FpHomebaseMarkers } = fpVisitMarkerFactory(
    {
        VisitMarkerPopup: FpHomebaseMarker,
        VisitMarkerPopupOuter: FpVisitMarkerPopupOuter
    },
    { themed: true }
);
type Props = {
    visit: BeatVisit,
    beatId: ?string,
    label: string | number,
    color: Array<Color> | Color,
    isHovered?: boolean,
    isPopupOpen?: boolean,
    withArrow?: boolean,
    isContextMenuOpen: boolean,
    isPlanEditable?: boolean,
    $hover?: boolean,
    theme?: ThemeType,
    getContainer: () => string,
    $onMouseAllow?: Function,
    onVisitClick: () => (beatId: string, visitId: string) => void,
    onHover: (beatId?: string, visitId: string) => void,
    onHoverOut: () => void,
    onContextMenu?: (
        x: number,
        y: number,
        beatId: string,
        visitId: string
    ) => void,
    lat: number,
    lng: number,
    salesCategory: string,
    salesmanId: ?string,
    isSelected: boolean,
    markerType: string,
    onMarkerPopUpCloseClick: () => void,
    parentElRefForMarker: {
        current: ?HTMLDivElement
    },
    outletData: ?VisitIdOutletType,
    status: string,
    sourceIndex: number,
    selectedVisit?: string,
    isFlagMarker?: boolean,
    isHomebaseMarker?: boolean
};

class BeatVisitMarker extends React.Component<Props> {
    onHover = (beatId: string, visitId: string) => {
        const { onHover } = this.props;
        onHover && onHover(beatId, visitId);
    };

    onVisitMarkerClick = (beat, visitId) => {
        const { onVisitClick } = this.props;
        onVisitClick && onVisitClick(beat, visitId);
    };

    onHoverOut = () => {
        const { onHoverOut } = this.props;
        onHoverOut();
    };

    render() {
        const { isFlagMarker, isHomebaseMarker, visit, ...rest } = this.props;
        const { outletVisitId, userVisitType } = visit;
        const disableContextMenu = false;
        if (isHomebaseMarker) {
            return (
                <FpHomebaseMarkers
                    {...rest}
                    visit={visit}
                    disableContextMenu={disableContextMenu}
                    onVisitMarkerClick={this.onVisitMarkerClick}
                    onHover={this.onHover}
                    onHoverOut={this.onHoverOut}
                    sourceId={outletVisitId || userVisitType}
                />
            );
        }
        if (isFlagMarker) {
            return (
                <FpFlagMarker
                    {...rest}
                    visit={visit}
                    disableContextMenu={disableContextMenu}
                    onVisitMarkerClick={this.onVisitMarkerClick}
                    onHover={this.onHover}
                    onHoverOut={this.onHoverOut}
                    sourceId={
                        this.props.visit.outletVisitId
                            ? this.props.visit.outletVisitId
                            : this.props.visit.userVisitType
                    }
                />
            );
        } else {
            return (
                <FpVisitMarker
                    {...rest}
                    visit={visit}
                    disableContextMenu={disableContextMenu}
                    onVisitMarkerClick={this.onVisitMarkerClick}
                    onHover={this.onHover}
                    onHoverOut={this.onHoverOut}
                    sourceId={
                        this.props.visit.outletVisitId
                            ? this.props.visit.outletVisitId
                            : this.props.visit.userVisitType
                    }
                />
            );
        }
    }
}

export default (themr(
    'BeatVisitMarker',
    theme
)(BeatVisitMarker): React.AbstractComponent<Props>);
